import { render, staticRenderFns } from "./FeedGood.vue?vue&type=template&id=3cacc1d6&scoped=true"
import script from "./FeedGood.vue?vue&type=script&lang=js"
export * from "./FeedGood.vue?vue&type=script&lang=js"
import style0 from "./FeedGood.vue?vue&type=style&index=0&id=3cacc1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cacc1d6",
  null
  
)

export default component.exports